import React from 'react'
import { Box, Button } from 'theme-ui'
import Navigation from '../../components/Navigation/index'
import Drawer from '../../components/Drawer/index'
import useSiteMetadata from '../../helpers/useSiteMetadata'
import attachSocialIcons from '../../helpers/attachSocialIcons'
import { Link as GLink } from 'gatsby'
import Divider from '../../components/Divider'

const styles = {
  desktopMenu: {
    display: [`none`, null, `block`]
  },
  mobileMenu: {
    display: [`block`, null, `none`]
  },
  desktopMenuWrapper: {
    justifyContent: 'flex-end',
    gap: `1rem`,
  },
  mobileMenuWrapper: {
    flexDirection: `column`,
    alignItems: 'flex-start'
  },
}

export const HeaderMenu = ({ mobileMenu = {} }) => {
  const { headerMenu, social} = useSiteMetadata()

  const desktopMenuNav = (
    <Navigation
      variant='horizontal'
      items={headerMenu}
      wrapperStyle={styles.desktopMenuWrapper}
      headingProps={{variant: 'h3'}}
      weight='600'
    />
  )

  const mobileMenuNav = (
    <Drawer>
      <Navigation
        variant='vertical'
        headingProps={{ variant: 'h3' }}
        items={[
          {
            title: 'Main Menu',
            items: headerMenu
          },
          mobileMenu
        ]}
        wrapperStyle={styles.mobileMenuWrapper}
      />
      <Navigation
        iconOnly={true}
        headingProps={{ variant: 'h3' }}
        items={
          [{title:'Social Media' , items: attachSocialIcons(social)}]}
        variant='horizontal'
      />
      <Divider line/>
      <Button as='a' href='https://www.paypal.com/donate/?hosted_button_id=7GN5DXUB25RV8' target='_blank' rel= 'noopener noreferrer'>Donate</Button>
    </Drawer>
  )

  return (
    <>
      <Box sx={styles.desktopMenu}>{desktopMenuNav}</Box>
      <Box sx={styles.mobileMenu}>{mobileMenuNav}</Box>
    </>
  )
}
